import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ThanksPage = lazy(() => import('../pages/thanks/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/thanks',
    element: <ThanksPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
